import React from 'react';
import { Mode, SelectableButton } from '@components/ringil3/Buttons/SelectableButton';
import { toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  model: ClickableItem[];
  selectedItemCode: string;
  onSelect: (selectedItemCode: string) => void;
  disabled?: boolean;
  dataTestIdPrefix?: string;
  // Whether to render the check icon on the selected option. Defaults to true; pass false for
  // segmented range/role pickers.
  showCheckIcon?: boolean;
}

interface ClickableItem {
  code: string;
  label: string;
  dataTestId?: string;
}

const InputSelect: React.FC<ComponentProps> = ({ model, selectedItemCode, onSelect, disabled, dataTestIdPrefix, showCheckIcon = true }) => {
  return (
    <div className="flex gap-2 h-10 cursor-pointer">
        {model.map((item, itemPos) => {
          const itemTestId = dataTestIdPrefix
            ? (item.dataTestId ? `${dataTestIdPrefix}-${item.dataTestId}` : `${dataTestIdPrefix}-${toTestIdSlug(item.code)}`)
            : undefined;
          return (
            <SelectableButton
              key={itemPos}
              label={item.label}
              onClick={() => (!disabled ? onSelect(item.code) : {})}
              checked={item.code === selectedItemCode}
              mode={item.code === selectedItemCode ? Mode.Checked : disabled ? Mode.Disabled : Mode.Active}
              dataTestId={itemTestId}
              showCheckIcon={showCheckIcon}
            />
          );
        })}
      </div>
  );
};

export default InputSelect;
